export default {
    SLIDE_RECEIVED: 'SLIDE_RECEIVED',
    SLIDE_REMOVED: 'SLIDE_REMOVED',
    SLIDE_MOVED: 'SLIDE_MOVED',

    SLIDE_CHANGING: 'SLIDE_CHANGING'
};
